import styled from 'styled-components';
import errorIcon from 'images/icons/errors/general-error.svg';
import noDataIcon from 'images/icons/errors/general-no-data.svg';
import contentOverTimeErrorIcon from 'images/icons/errors/content-over-time.svg';
import numContentPiecesErrorIcon from 'images/icons/errors/num-content-pieces.svg';
import entityListCardErrorIcon from 'images/icons/errors/entity-list-card.svg';
import { StyledTag } from 'components/Global/Tag/styled.js';
import { LabelName, LabelValue, HorizontalBarFill, HorizontalBarContainer } from 'components/Graphs/FillBars/styled.js';
import { Value, StyledContentTitle } from 'components/Pages/Reports/EntityOverview/styled.js';
import { EntityIcon } from 'components/Global/EntityItem/styled.js';

const errorIconMap = {
  noData: noDataIcon,
  error: errorIcon,
  contentOverTime: contentOverTimeErrorIcon,
  numContentPieces: numContentPiecesErrorIcon,
  listCard: entityListCardErrorIcon,
};

export const ErrorWrapper = styled.div`
  ${StyledTag} {
    background-color: #E2E2E2;
    border: none;
  }
  ${Value} {
   color: #CBCED6; 
  }
  ${StyledContentTitle} {
    display: inline-block;
    margin-bottom: 5px;
    /* vertical-align: middle;
    height: 28px; */
  }
`;

export const ErrorIconContainer = styled.div`
  position: relative;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '271px'};
`;

export const ErrorTitle = styled.div`
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1px;
  color: ${({ dark }) => dark ? '#939AAB' : '#CBCED6'};
  margin-bottom: 20px;
  text-transform: ${({ uppercase }) => uppercase ? 'uppercase' : 'capitalize'};
`;

export const ErrorText = styled.div`
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  color: #939AAB;

  > span {
    color: #2D8BFF;
  }
`;

export const ErrorDescriptionContainer = styled.div`
  width: ${({ width }) => width ? `${width}` : '100%'};
  text-align: ${({ left }) => left ? 'left' : 'center'};
  margin: 20px auto;
`;

export const StyledErrorIcon = styled.div`
  vertical-align: middle;
  background-image: ${({ type }) => `url('${errorIconMap[type]}')`};
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  background-color: white;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const StyledErrorButtonText = styled.div`
  font-size: 10px;
  line-height: 14px;
  font-weight: bold;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: white;
`;

export const StyledErrorButton = styled.div`
  width: 95px;
  height: 32px;
  padding: 10px 13px 9px 13px;
  text-align: center;
  background: #2D8BFF;
  border-radius: 5px;
  margin: 23px auto;
  cursor: pointer;
`;

export const ErrorTitleGroupContainer = styled.div`
  text-align: left;

  ${ErrorTitle} {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 30px;

    span:nth-child(1) {
      margin-left: 14px;
    }
  }
`;

export const ErrorDateContainer = styled.span`
  display: inline-block;
  width: 95px;
  padding: 5px 5px 3px 5px;
  background: #F3F4F5;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  line-height: 17px;
`;

export const ErrorFillBarContainer = styled.div`
  ${LabelName}, ${LabelValue} {
    text-transform: initial;
    color: #939AAB!important; /* im sorry */
  }
  ${HorizontalBarContainer} {
    background-color: #F3F4F5;
  }
  ${HorizontalBarFill} {
    background-color: #E4E5E9;
  }
  ${EntityIcon} {
    background-color: #F3F4F5;
  }
`;

export const StyledErrorCardContainer = styled.div`
  width: 100%;
  max-width: 351px;
  height: 370px;
  background: linear-gradient(33.32deg, #E4E5E9 0%, #FBFBFC 100%);
  border-radius: 20px;
  padding: 30px;
  margin: auto;
`;

export const StyledErrorCardContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const EmptyContentBar = styled.div` 
  width: ${({ width }) => width || '284px'};
  max-width: 100%;
  height: 16px;
  background: ${({ light }) => light ? '#F3F4F5' : 'rgba(203, 206, 214, 0.5)'};
  border-radius: 20px;
  margin-bottom: 7px;
`;

export const EmptyEntityTitleBar = styled.div` 
  display: inline-block;
  width: ${({ width }) => width || '284px'};
  max-width: 100%;
  height: 9px;
  background: #F3F4F5;
  border-radius: 20px;
`;

export const EmptyContentTypeIcon = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #F3F4F5;
  margin-right: 5px;
`;

export const EmptyEntityIcon = styled.div`
  display: inline-block;
  width: ${({ width }) => width || '28px'};
  height: ${({ height }) => height || '28px'};
  border-radius: 50%;
  margin-right: 5px;
  background-color: rgba(203, 206, 214, 0.5);
`;

export const ErrorCardText = styled.div`
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #CBCED6;
  margin: 10px 0;
`;

export const ErrorEmptyTagContainer = styled.div`
  display: inline-block;
  text-align: center;
  width: 100%;
`;

export const ErrorEmptyTag = styled.div`
  width: 52px;
  height: 20px;
  background: #E4E5E9;
  border-radius: 14px;
  margin-right: 3px;
  display: inline-block;
`;
